// Game cost constants with descriptive names
// EVIL_COST: Special premium game with highest stakes
// GO/BALL/WORD: Mid-tier games with varying difficulty
// STANDARD: Base cost for most games
export const GAME_COSTS = {
  EVIL: 666,      // Premium evil monkey game
  GO: 500,        // Direction matching game
  BALL: 200,      // Sports emoji matching
  WORD: 100,      // Four letter word game
  STANDARD: 20    // Base cost for standard games
};

// Featured games with specific stats
export const FEATURED_GAMES = [
  { id: 'evil', cmd: '!evil', cost: GAME_COSTS.EVIL, cooldown: '30 mins', winRate: '11%', win: '🙈🙉🙊 Match', link: 'https://docs.google.com/document/d/1ZfVBQZhnSQwUufso_ZR-QtIF7zbZDDXTZUc4xnCbdNc/edit?usp=sharing' },
  { id: 'go', cmd: '!go', cost: GAME_COSTS.GO, cooldown: '30 mins', winRate: '10.9%', win: '👆👇👉👈 Match Or One Each', link: 'https://docs.google.com/document/d/1H6K9dLK8DL8Q8EqViPzAbtGvvmy5_L_KxVmelS7YzmM/edit?usp=sharing' },
  { id: 'ball', cmd: '!ball', cost: GAME_COSTS.BALL, cooldown: '30 mins', winRate: '1.23%', win: '🏈🏀⚾ Match', link: 'https://docs.google.com/document/d/11cqITG_kuMWK1yusU2e9biRPfKYOTfgxorakwyiLIr4/edit?usp=sharing' },
  { id: 'word', cmd: '!word', cost: GAME_COSTS.WORD, cooldown: '30 mins', winRate: '.88%', win: 'Get a four letter word', link: 'https://docs.google.com/document/d/1GRlpTJgjwOSGwwIji00T-7y8KV6YpHsW3Lw_r4zv4sc/edit?usp=sharing' },
  { id: 'lurk', cmd: '!lurk', cost: GAME_COSTS.STANDARD, cooldown: '30 mins', winRate: '.39%', win: 'Get ⓁⓊⓇⓀ', link: 'https://docs.google.com/document/d/1vaMASbpx7ItA13UQ_Yw8RSKXnSCwHUWLIEmuKU55vuw/edit?usp=sharing' },
  { id: 'gimme', cmd: '!gimme (100-999)', cost: GAME_COSTS.STANDARD, cooldown: '30 mins', winRate: '.11%', win: 'Lottery', link: 'https://docs.google.com/document/d/1Au20MsjCeme5jLn1l8anndq-H76hpFxWZaHQMrcsGs0/edit?usp=sharing' },
  { id: 'squid', cmd: '!squid', cost: GAME_COSTS.STANDARD, cooldown: '30 mins', winRate: '.09%', win: 'Squid1|Squid2|Squid3|Squid2|Squid4', link: 'https://docs.google.com/document/d/1kTIzR1iHPYNOOONbZPcoZvJ8mth2jSwmCXGw-OSfChM/edit?usp=sharing' },
  { id: 'math', cmd: '!math', cost: GAME_COSTS.STANDARD, cooldown: '30 mins', winRate: '~1%', win: 'Proper math equation', link: 'https://docs.google.com/document/d/1YLUCtZ_YyDFSjDDytwN16BDnXDaesh-bkZi68W6uixw/edit?usp=sharing' },
];

// Standard games with same cost/cooldown/win rate
export const STANDARD_GAMES = [
  { id: 'unlock', cmd: '!unlock', win: '5x🔓' },
  { id: 'taco', cmd: '!taco', win: '5x🌮' },
  { id: 'sun', cmd: '!sun', win: '5x🌞' },
  { id: 'star', cmd: '!star', win: '5x🌟' },
  { id: 'queen', cmd: '!queen', win: '5x👸' },
  { id: 'poop', cmd: '!poop', win: '5x💩' },
  { id: 'king', cmd: '!king', win: '5x🤴' },
  { id: 'high5', cmd: '!high5', win: '5x🙏' },
  { id: 'gear', cmd: '!gear', win: '5x⚙️' },
  { id: 'fck', cmd: '!f*ck', win: '5x🤬' },
  { id: 'flag', cmd: '!flag', win: '5x🏳️‍🌈' },
  { id: 'face', cmd: '!face', win: '5x🥰' },
  { id: 'eggplant', cmd: '!eggplant', win: '5x🍆' },
  { id: 'dog', cmd: '!dog', win: '5x🐶' },
  { id: 'dino', cmd: '!dino', win: '5x DinoDance' },
  { id: 'clock', cmd: '!clock', win: '5x🕙' },
  { id: 'cat', cmd: '!cat', win: '5x🐱' },
  { id: 'cash', cmd: '!cash', win: '5x💲' },
  { id: 'cake', cmd: '!cake', win: '5x🎂' },
  { id: 'ET', cmd: '!ET', win: '5x👽' },
  { id: 'Bob', cmd: '!Bob', win: '5x CoolStoryBob' }
];

export const STANDARD_GAMES_LINK = 'https://docs.google.com/document/d/11He1cUcnFhfEsoWOS_h96TyTaUkgguEey6EsT15lnV8/edit?usp=sharing';

// Social links
export const SOCIAL_LINKS = [
  { name: 'Twitch', url: 'https://www.twitch.tv/CiroGameShowTwitch', icon: 'Twitch', color: 'hover:bg-purple-600' },
  { name: 'YouTube', url: 'https://www.youtube.com/@CiroGameShow', icon: 'Youtube', color: 'hover:bg-red-600' },
  { name: 'Twitter', url: 'https://twitter.com/CiroGameShow', icon: 'Twitter', color: 'hover:bg-blue-500' },
  { name: 'Instagram', url: 'https://www.instagram.com/cirogameshow/', icon: 'Instagram', color: 'hover:bg-pink-600' }
];

// Giveaway config
export const GIVEAWAY_CONFIG = {
  name: 'Enter for a chance to win a $5 Amazon Gift Card!',
  url: 'https://gleam.io/zyqMG/cirogameshow-entry'
};

// Merch config
export const MERCH_CONFIG = {
  image: "https://customer-assets.emergentagent.com/job_stream-and-sell-1/artifacts/y4tvr8kt_Monkey%20game%20show%20host%20in%20action%20Pixlr%20Image%20Edit%20Use%20For%20T-Shirt.png",
  purchaseLink: "https://ebay.us/m/yBPEcX"
};
